<template>
  <iframe ref="previewFrame"></iframe>
</template>

<script>

export default {
  mounted() {
    this.loadIframeContent();
    window.addEventListener('message', this.handleMessage);
  },
  beforeUnmount() {
    window.removeEventListener('message', this.handleMessage);
  },
  data: () => ({
    // eslint-disable-next-line new-cap
    uniqueNumber: Number.UNIQUE(),
  }),
  props: {
    params: {
      default: {},
      required: false,
    },
  },
  methods: {
    async loadIframeContent() {
      if (this.htmlDrawFile) {
        const iframe = this.$refs.previewFrame;
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        doc.open();
        doc.FILE_PREVIEW_NUMBER = this.uniqueNumber;
        doc.write(this.htmlDrawFile);
        doc.close();
      }
    },
    async handleMessage(event) {
      const message = event.data;

      if (message.target != this.uniqueNumber) return;

      if (message.type == 'get_env') {
        event.source.postMessage({
          'type': 'set_env',
          'target': this.uniqueNumber,
          'uid': message.uid,
          'preview_number': this.uniqueNumber,
          'file_path': this.filePath,
          'api_methods': [
            'get_env', 'set_file', 'get_file',
          ],
        }, event.origin);
      }
      if (message.type == 'set_file') {
        const fileBlob = new Blob([message.file_data], {type: message.file_type});

        let fileDir = String(message.file_path).split('/');
        const fileName = fileDir[fileDir.length-1];
        fileDir.splice(-1, 1);
        fileDir = fileDir.join('/');

        const file = new File([fileBlob], fileName, {type: message.file_type});
        this.send_files(fileDir, file, (result) => {
          event.source.postMessage({
            'type': 'upload_file_result',
            'uid': message.uid,
            'target': this.uniqueNumber,
            'file_path': message.file_path,
            'file_type': message.file_type,
            'result': result,
          }, event.origin);
        });
      }
      if (message.type == 'get_file') {
        const file = await this.filesLocalDownloader(message.file_path);
        event.source.postMessage({
          'type': 'req_file',
          'uid': message.uid,
          'target': this.uniqueNumber,
          'file_path': message.file_path,
          'file_data': file,
        }, event.origin);
      }
    },
  },
  computed: {
    filePath() {
      return this.params.file_path;
    },
    send_files() {
      return this.params.send_files;
    },
    htmlDrawFile() {
      return this.params.draw_file;
    },
    filesLocalDownloader() {
      return this.params.files_local_downloader;
    },
  },
};
</script>

<style>
iframe {
  background-color: white;
  width: 75vw;
  height: 70vh;
}
</style>
